var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38999 8.00208L0.336035 14.0513C-0.111701 14.499 -0.111701 15.223 0.336035 15.666C0.78377 16.1137 1.50777 16.109 1.9555 15.666L8.81443 8.81182C9.24788 8.37837 9.2574 7.68295 8.84777 7.23522L1.96027 0.333419C1.7364 0.109552 1.44109 -6.73713e-07 1.15053 -6.99114e-07C0.859982 -7.24515e-07 0.564667 0.109552 0.340799 0.333419C-0.106936 0.781155 -0.106936 1.50515 0.340799 1.94813L6.38999 8.00208Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.05d14e5537fd279315f59f32afa8067d.svg";
export { ForwardRef as ReactComponent };